/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var _window;
var canUseDom = !!(typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && (_window = _window.document) !== null && _window !== void 0 && _window.createElement);
var canUseDom$1 = canUseDom;

export { canUseDom$1 as default };
